export default __webpack_public_path__ + "9adec1e.png";